import styled from 'styled-components';

export const Button = styled.button`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 120;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(255, 100, 100, 0.35);
  background: radial-gradient(circle at 35% 30%, rgba(255, 68, 100, 0.2), rgba(0, 17, 34, 0.9));
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  backdrop-filter: blur(6px);
  box-shadow:
    0 0 14px rgba(255, 68, 100, 0.25),
    inset 0 0 10px rgba(255, 68, 100, 0.08);
  transition: all 0.25s ease;

  &:hover {
    border-color: rgba(255, 100, 100, 0.6);
    box-shadow:
      0 0 22px rgba(255, 68, 100, 0.4),
      inset 0 0 14px rgba(255, 68, 100, 0.15);
  }

  &:active {
    transform: scale(0.92);
  }

  @media (max-width: 768px) {
    top: 12px;
    right: 12px;
    width: 38px;
    height: 38px;
  }
`;

export const Icon = styled.img`
  width: 42%;
  height: 42%;
  object-fit: contain;
  pointer-events: none;
  filter: brightness(0) invert(0.55) sepia(1) saturate(5) hue-rotate(330deg);
`;
